module.exports = __webpack_public_path__ + "h5/img/child-nav2.e9fc1c79.png";